<template>
  <v-toolbar
    :dense="isSmallDevice"
    flat
    :color="appColor_Background"
    :height="isSmallDevice ? '30' : '60'"
    class="mb-2">

    <!-- Logo -->
    <v-img
      v-if="pageLogoUrl !== null"
      :src="pageLogoUrl"
      :max-width="logoMaxWidth"
      class="mr-2"
    />

    <!-- Icon -->
    <v-icon
      v-else
      :x-large="!isSmallDevice"
      :color="appColor_TitleIcon"
      :class="titleIconClass">
      {{ icon }}
    </v-icon>

    <!-- Title -->
    <v-toolbar-title :class="titleClass + ' ' + appColor_Title">
      {{ title }}
    </v-toolbar-title>

    <v-spacer />

    <!-- Button Icon (optional) -->
    <v-btn
      v-if="buttonIcon !== null"
      dark
      fab
      :color="appColor_Dark"
      :class="buttonClass"
      :small="isSmallDevice"
      :hidden="actionButtonHidden"
      @click="$emit('action-button-click')"
      >
      <v-icon :color="buttonIconColor" :large="!isSmallDevice">
        {{ buttonIcon }}
      </v-icon>
    </v-btn>

    <!-- Action Link (optional) -->
    <v-btn
      v-if="!actionLinkHidden && actionLink !== null"
      dark
      :color="appColor_Dark"
      :small="isSmallDevice"
      @click="$emit('action-link-click')"
      >
      <span :class="linkTextClass">{{ actionLink }}</span>
    </v-btn>
  </v-toolbar>
</template>

<script>
import { AppColor } from '@/config.js'
export default {
  name: "AppPageTitle",
  data () {
    return {
      appColor_Dark: AppColor.Dark,
      appColor_Background: AppColor.Background,
      appColor_TitleIcon: AppColor.PageTitleIcon,
      appColor_Title: AppColor.PageTitle
    }
  },
  props: {
    title: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    actionLink: {
      type: String,
      default: null
    },
    actionLinkHidden: {
      type: Boolean,
      default: false
    },
    actionButtonHidden: {
      type: Boolean,
      default: false
    },
    buttonIcon: {
      type: String,
      default: null
    },
    buttonIconColor: {
      type: String,
      default: null
    },
    pageLogoUrl: {
      type: String,
      default: null
    }
  },
  computed: {
    isSmallDevice () {
      return this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 'sm'
    },
    titleClass () {
      const fontWeight = 'font-weight-medium'
      return this.isSmallDevice
        ? 'subtitle-1 ' + fontWeight
        : 'display-1 ' + fontWeight
    },
    titleIconClass () {
      return this.isSmallDevice ? 'mr-1' : 'mr-2'
    },
    linkTextClass () {
      return this.isSmallDevice
        ? 'caption' //  + color
        : 'subtitle-1' // + color
    },
    buttonClass () {
      return this.actionLinkHidden
        ? 'mr-0'
        : 'mr-2'
    },
    logoMaxWidth () {
      return this.isSmallDevice ? "25" : "50"
    }
  }
}
</script>
